import { useEffect, useState } from "react";

export const FontSizeControls = () => {
  const [scale, setScale] = useState(() => {
    const v = parseFloat(localStorage.getItem("site_font_scale") || "1");
    return Number.isFinite(v) && v >= 1 && v <= 1.6 ? v : 1;
  });
  const [lift, setLift] = useState(0);

  useEffect(() => {
    // root font-size (rem) αντί για CSS zoom: το zoom στο iOS Safari ξεχείλωνε τη σελίδα οριζόντια
    document.documentElement.style.zoom = "";
    document.documentElement.style.fontSize = scale === 1 ? "" : `${Math.round(16 * scale * 100) / 100}px`;
    localStorage.setItem("site_font_scale", String(scale));
  }, [scale]);

  useEffect(() => {
    const check = () => {
      const bar = document.querySelector('[data-testid="workshop-cta-sticky"], [data-sticky-bar]');
      const r = bar ? bar.getBoundingClientRect() : null;
      setLift(r && r.height > 0 ? r.height + 8 : 0);
    };
    check();
    const t = setInterval(check, 700);
    return () => clearInterval(t);
  }, []);

  const step = (d) => setScale((s) => Math.min(1.6, Math.max(1, Math.round((s + d) * 100) / 100)));

  if (window.self !== window.top) return null; // μέσα σε iframe (προεπισκόπηση /8w01) τα δείχνει ήδη η εξωτερική σελίδα
  return (
    <div className="fixed left-4 z-[60] flex items-center gap-1.5 transition-[bottom] duration-300"
      style={{ bottom: `${16 + lift}px` }} data-testid="global-font-controls">
      <button onClick={() => step(-0.15)} title="Μικρότερα γράμματα" data-testid="global-font-smaller"
        className="w-9 h-9 rounded-full text-xs font-bold shadow-lg transition-colors"
        style={{ background: "rgba(11,26,46,0.95)", color: "#F5EFE0", border: "1px solid rgba(245,239,224,0.35)" }}>
        A−
      </button>
      <button onClick={() => step(0.15)} title="Μεγαλύτερα γράμματα" data-testid="global-font-bigger"
        className="w-9 h-9 rounded-full text-sm font-bold shadow-lg transition-colors"
        style={{ background: "rgba(11,26,46,0.95)", color: "#F5EFE0", border: "1px solid rgba(245,239,224,0.35)" }}>
        A+
      </button>
    </div>
  );
};
